const camelToKebabCase = (str) => str.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase();
const actionToAttrName = (action) => `data-${camelToKebabCase(action)}`;
const TriggerApi = 'PlatformCustomElementTriggerApi';

export const exposeApi = (customEl, api) => {
    customEl.on(TriggerApi, async (event) => {
        const {action, args} = event.detail;
        if (api[action]) {
            const res = await api[action](...args);
            customEl.setAttribute(actionToAttrName(action), JSON.stringify(res));
        }
    });
};